import { Injectable, inject } from '@angular/core';
import { TwcRefreshLayerPluginService } from '../../../twc.refresh-layer-plugin.service';
import { HIGH_LEVEL_SIGNIFICANT_LEGEND } from './high-level-significant.legend';
import { HIGH_LEVEL_SIGNIFICANT_PRODUCT_DATA } from './high-level-significant.twc-product-data';

@Injectable({
  providedIn: 'root'
})
export class HighLevelSignificantPluginService {
  private _twcPluginService = inject(TwcRefreshLayerPluginService);

  plugin$ = this._twcPluginService.create(HIGH_LEVEL_SIGNIFICANT_PRODUCT_DATA, {
    legend: HIGH_LEVEL_SIGNIFICANT_LEGEND,
    twcLayerTypes: ['vector-tile', 'geojson']
  });
}
